import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { func } from 'prop-types';
import { getDestination } from '../selectors';
import { setProfileCookieFromLocalStorage, getProfileUser, initializeEidProfile } from '../utils';

const SetLocalStorageCookie = ({ changeUserProfile }) => {
  const destination = useSelector(getDestination);

  useEffect(() => {
    if (global.BROWSER && destination) {
      initializeEidProfile();
      setProfileCookieFromLocalStorage(destination);
      const profileUserId = getProfileUser() || '';
      changeUserProfile(profileUserId);
    }
  }, [destination]);

  return null;
};

SetLocalStorageCookie.propTypes = {
  changeUserProfile: func.isRequired,
};

export default SetLocalStorageCookie;
